import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "btn-unstyled"
}

import { mdiAlert, mdiInformationOutline } from "@mdi/js";


export default /*@__PURE__*/_defineComponent({
  __name: 'Hint',
  props: {
  position: {
    required: false,
    default: "bottom",
    type: String,
    validator: (value: string) => {
      return [
        "top",
        "bottom",
        "left",
        "right",
        "top-end",
        "top-start",
        "left-start",
        "left-end",
        "right-start",
        "right-end",
        "bottom-start",
        "bottom-end"
      ].includes(value);
    }
  },
  type: {
    required: true,
    default: "info",
    type: String,
    validator: (value: string) => {
      return ["info", "warning", "error"].includes(value);
    }
  },
  iconSize: {
    // possible options - any numbers
    type: Number,
    required: false,
    default: 24
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_tippy = _resolveComponent("tippy")!

  return (_openBlock(), _createBlock(_component_tippy, {
    class: _normalizeClass(['hint', __props.type]),
    placement: __props.position,
    interactive: true,
    arrow: true,
    theme: 'hint'
  }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", _hoisted_1, [
        (__props.type === 'info')
          ? (_openBlock(), _createBlock(_component_SVGIcon, {
              key: 0,
              path: _unref(mdiInformationOutline),
              size: __props.iconSize,
              type: "is-light"
            }, null, 8, ["path", "size"]))
          : (__props.type === 'warning')
            ? (_openBlock(), _createBlock(_component_SVGIcon, {
                key: 1,
                path: _unref(mdiAlert),
                size: __props.iconSize,
                type: "is-warning"
              }, null, 8, ["path", "size"]))
            : (__props.type === 'error')
              ? (_openBlock(), _createBlock(_component_SVGIcon, {
                  key: 2,
                  path: _unref(mdiAlert),
                  size: __props.iconSize,
                  type: "is-danger"
                }, null, 8, ["path", "size"]))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["class", "placement"]))
}
}

})